import { render, staticRenderFns } from "./CharacterSelect.vue?vue&type=template&id=53fa715a&scoped=true&"
import script from "./CharacterSelect.vue?vue&type=script&lang=js&"
export * from "./CharacterSelect.vue?vue&type=script&lang=js&"
import style0 from "./CharacterSelect.vue?vue&type=style&index=0&id=53fa715a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fa715a",
  null
  
)

export default component.exports